"use strict";

exports.__esModule = true;
exports.CompactListIcon = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var CompactListIcon = exports.CompactListIcon = function CompactListIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: props.height,
    viewBox: "0 0 32 32",
    width: props.width
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 20.291,
    y: 41.513,
    width: 11.914,
    height: 2.6,
    transform: "matrix(.99999 .0044 0 1.00001 -3.565 -35.083)",
    rx: 0.327,
    ry: 0.327,
    fill: "rgba(81,81,81,.35)"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 4.428,
    y: 41.51,
    width: 2.6,
    height: 2.6,
    transform: "matrix(.99998 .00633 0 1.00002 -1.131 -35.132)",
    rx: 0.327,
    ry: 0.327,
    fill: "#515151"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 17.376,
    y: 41.513,
    width: 10.202,
    height: 2.6,
    transform: "matrix(.99999 .0044 0 1.00001 -11.15 -35.136)",
    rx: 0.327,
    ry: 0.327,
    fill: "#515151"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 20.291,
    y: 41.513,
    width: 11.914,
    height: 2.6,
    transform: "matrix(.99999 .0044 0 1.00001 -3.571 -31.264)",
    rx: 0.327,
    ry: 0.327,
    fill: "rgba(81,81,81,.35)"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 4.428,
    y: 41.51,
    width: 2.6,
    height: 2.6,
    transform: "matrix(.99998 .00633 0 1.00002 -1.137 -31.314)",
    rx: 0.327,
    ry: 0.327,
    fill: "#515151"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 17.376,
    y: 41.513,
    width: 10.202,
    height: 2.6,
    transform: "matrix(.99999 .0044 0 1.00001 -11.156 -31.317)",
    rx: 0.327,
    ry: 0.327,
    fill: "#515151"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 20.291,
    y: 41.513,
    width: 11.914,
    height: 2.6,
    transform: "matrix(.99999 .0044 0 1.00001 -3.537 -27.387)",
    rx: 0.327,
    ry: 0.327,
    fill: "rgba(81,81,81,.35)"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 4.428,
    y: 41.51,
    width: 2.6,
    height: 2.6,
    transform: "matrix(.99998 .00633 0 1.00002 -1.103 -27.436)",
    rx: 0.327,
    ry: 0.327,
    fill: "#515151"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 17.376,
    y: 41.513,
    width: 10.202,
    height: 2.6,
    transform: "matrix(.99999 .0044 0 1.00001 -11.122 -27.44)",
    rx: 0.327,
    ry: 0.327,
    fill: "#515151"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 20.291,
    y: 41.513,
    width: 11.914,
    height: 2.6,
    transform: "matrix(.99999 .0044 0 1.00001 -3.502 -23.363)",
    rx: 0.327,
    ry: 0.327,
    fill: "rgba(81,81,81,.35)"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 4.428,
    y: 41.51,
    width: 2.6,
    height: 2.6,
    transform: "matrix(.99998 .00633 0 1.00002 -1.068 -23.412)",
    rx: 0.327,
    ry: 0.327,
    fill: "#515151"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 17.376,
    y: 41.513,
    width: 10.202,
    height: 2.6,
    transform: "matrix(.99999 .0044 0 1.00001 -11.087 -23.415)",
    rx: 0.327,
    ry: 0.327,
    fill: "#515151"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 20.291,
    y: 41.513,
    width: 11.914,
    height: 2.6,
    transform: "matrix(.99999 .0044 0 1.00001 -3.502 -19.076)",
    rx: 0.327,
    ry: 0.327,
    fill: "rgba(81,81,81,.35)"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 4.428,
    y: 41.51,
    width: 2.6,
    height: 2.6,
    transform: "matrix(.99998 .00633 0 1.00002 -1.068 -19.125)",
    rx: 0.327,
    ry: 0.327,
    fill: "#515151"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 17.376,
    y: 41.513,
    width: 10.202,
    height: 2.6,
    transform: "matrix(.99999 .0044 0 1.00001 -11.087 -19.129)",
    rx: 0.327,
    ry: 0.327,
    fill: "#515151"
  }));
};